module.exports = {
	"shared.crew.original-music-composer": "필름",
	"social-button.twitter": "Twitter",
	"shared.crew.publicist": "카피라이터",
	"share-overlay.share": "공유하기",
	"shared.crew.associate-producer": "미술",
	"shared.crew.assistant-editor": "프로덕션 디자이너",
	"overlay.buy-from": "최저 {price}",
	"shared.crew.agent": "각색",
	"shared.crew.additional-photography": "각본",
	"shared.crew.sound-editor": "메이킹",
	"shared.crew.print-shipper": "현상",
	"shared.crew.hairstylist": "스토리보드",
	"shared.crew.makeup-effects": "현장스틸",
	"social-button.pinterest": "Pinterest",
	"shared.crew.production-assistant": "텔레시네",
	"shared.crew.executive-producer": "조감독",
	"shared.crew.costumer": "스턴트",
	"info-overlay.cast": "출연진",
	"shared.crew.stunt-coordinator": "공동감독",
	"shared.crew.academic-advisor": "투자",
	"shared.crew.swing-gang": "공동기획",
	"shared.crew.best-boy": "세트",
	"actions.purchased": "구매한 동영상",
	"social-button.tumblr": "Tumblr",
	"quality.format": "{qualityValue}p",
	"shared.crew.set-decorator": "웹디자인",
	"shared.crew.adaptation": "제작",
	"shared.crew.school-administrator": "자막제작",
	"shared.crew.cable-person": "의상",
	"shared.crew.digital-effects": "무술",
	"actions.rent": "대여 {price}",
	"info-overlay.created-by": "각본 {author}",
	"social-share.twitter": "<\"{title}\">! {siteUrl}에서 시청하세요! ",
	"shared.crew.production-designer": "운송",
	"info-overlay.crew": "제작진",
	"shared.crew.producer": "색보정",
	"shared.crew.2nd-unit-dir-of-photography": "배급",
	"shared.crew.special-effects": "감사",
	"actions.rented": "대여한 동영상 ({date}까지)",
	"shared.crew.boom-operator": "소품",
	"shared.crew.story": "특별감사",
	"shared.crew.script-supervisor": "광고디자인",
	"shared.crew.director": "CG",
	"shared.crew.choreographer": "분장/헤어",
	"shared.crew.production-manager": "마케팅",
	"quality.auto": "자동",
	"shared.crew.lead-person": "캐스팅",
	"shared.crew.location-manager": "로케이션",
	"shared.crew.costume-designer": "무술",
	"fullscreen.exit": "전체화면 닫기",
	"shared.crew.technical-advisor": "공동투자",
	"shared.crew.editor": "편집",
	"shared.crew.additional-grip": "원작자",
	"actions.buy": "구매 {price}",
	"shared.crew.assistant-camera": "촬영보조",
	"shared.crew.writer": "동물트레이너",
	"social-share.pinterest": "{title} - {description}",
	"shared.crew.collaborating-director": "특수분장",
	"fullscreen.enter": "전체화면",
	"shared.crew.animal-trainer": "감독",
	"shared.crew.assistant-art-director": "라인 프로듀서",
	"shared.crew.key-grip": "제작고문",
	"social-button.copy": "복사",
	"shared.crew.makeup-artist": "회계",
	"overlay.source-error": "재생할 수 없는 동영상입니다.",
	"social-button.link": "링크",
	"actions.buy-from": "최저 {price}",
	"shared.crew.art-director": "제작 프로듀서",
	"shared.crew.production-coordinator": "옵티컬",
	"shared.crew.co-director": "편집",
	"shared.crew.co-producer": "현장편집",
	"shared.crew.video-operator": "공동배급",
	"shared.crew.camera-operator": "특수의상",
	"shared.crew.co-writer": "특수효과",
	"shared.crew.set-designer": "예고편",
	"shared.crew.preview-return": "장비대여",
	"shared.crew.property-master": "온라인마케팅",
	"shared.crew.cinematographer-dp": "음악",
	"shared.crew.grip": "스크립터",
	"social-share.tumblr": "{title} - {siteUrl}",
	"shared.crew.sound-mixer": "협찬",
	"quality.label": "품질",
	"social-button.facebook": "Facebook",
	"shared.crew.gaffer": "연출",
	"shared.crew.assistant-director": "조명",
	"actions.subscribe": "월구독료 {price}",
	"shared.crew.print-return": "스테디캠",
	"shared.crew.animator": "프로듀서",
	"shared.crew.dolly-grip": "홍보",
	"shared.crew.manager": "특수장비",
	"shared.crew.2nd-assistant-director": "제공",
	"shared.crew.author-of-adapted-material": "시각효과"
};


//////////////////
// WEBPACK FOOTER
// ./src/widget/player-widget/translations/widget-texts_ko.json
// module id = 2792
// module chunks = 66